import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import { Nav, NavItem, NavLink } from 'reactstrap'
import "../../../static/css/index.css"

export const NavBar = class extends React.Component {
  render() {
    const activeTab = get(this.props, 'activeTab')
    const toggleTab = get(this.props, 'toggleTab')
    const canSeeOverall = get(this.props, 'canSeeOverall')
    const canSeeSubmit = get(this.props, 'canSeeSubmit')
    return (
      <NavbarTab tabs>
        { canSeeOverall &&
        <TabItem>
          <NavLinkTab
            style={ {
              color: (activeTab === 1) ? '#AD2624' : '',
              borderBottom: (activeTab === 1) ? '4px solid #AD2624' : '',
              borderTopStyle: 'none',
              borderLeftStyle: 'none',
              borderRightStyle: 'none',
            } }
            onClick={ () => {
              toggleTab(1)
              // if (isEdit) handleDiscard('clickTab', 1)
              // else toggleTab(1)
            }
            }
          >
                Overall
          </NavLinkTab>
        </TabItem>
        }
        <TabItem>
          <NavLinkTab
            style={ { color: (activeTab === 2) ? '#AD2624' : '',
              borderBottom: (activeTab === 2) ? '4px solid #AD2624' : '',
              borderTopStyle: 'none',
              borderLeftStyle: 'none',
              borderRightStyle: 'none',
            } }
            onClick={ () => {
              toggleTab(2)
              // if (isEdit) handleDiscard('clickTab', 2)
              // else toggleTab(2)
            }
            }
          >
              LOB Overview
          </NavLinkTab>
        </TabItem>
        { canSeeSubmit &&
        <TabItem>
          <NavLinkTab
            style={ { color: (activeTab === 3) ? '#AD2624' : '',
              borderBottom: (activeTab === 3) ? '4px solid #AD2624' : '',
              borderTopStyle: 'none',
              borderLeftStyle: 'none',
              borderRightStyle: 'none',
            } }
            onClick={ () => {
              toggleTab(3)
              // if (isEdit) handleDiscard('clickTab', 3)
              // else toggleTab(3)
            }
            }
          >
            LOB Submit
          </NavLinkTab>
        </TabItem>
        }
      </NavbarTab>
    )
  }
}

const NavbarTab = styled(Nav)`
  height: 100%;
  width: 70%;
  -webkit-box-shadow: 0px 1px 1px #F1F1F1;
  -moz-box-shadow: 0px 1px 1px #F1F1F1;
  box-shadow: 0px 1px 0px #F1F1F1;
  border: none;
  padding-top: 10px;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
  @media (max-width: 991.98px) {
    margin-right: 1%;
  }
  .nav-link {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
`
const NavLinkTab = styled(NavLink)`
  height: 40px;
  padding-bottom: 20px;
  cursor: pointer;
  font-size: 12px;
  &:hover{
    border: none ;
  }
`
const TabItem = styled(NavItem)`
  height: 30px ;
  .nav-link {
    display: block;
    @media (max-width: 1199.98px) {
      font-size: 10px;
      padding: 0.5rem 0.3rem !important;
    }
    @media (max-width: 991.98px) {
      font-size: 10px;
      padding: 0.5rem 0.3rem !important;
    }
    @media (max-width: 575.98px) {
      font-size: 12px;
      padding-bottom: 0px !important;
    }
    @media (max-width: 767.98px) {
      margin: auto;
    }
  }
`




// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab/navbar.js